import { render, staticRenderFns } from "./DashboardListTable.vue?vue&type=template&id=424da211&"
import script from "./DashboardListTable.vue?vue&type=script&lang=js&"
export * from "./DashboardListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports